module.exports = __webpack_public_path__ + "img/payok.1ee05fed.png";